import { z } from "zod";

export const settingsSchema = z.object({
  name: z.string().min(1, "Company name is required"),
  address: z.string().min(1, "Address is required"),
  phoneNumber: z
    .string()
    .min(1, "Phone number is required")
    .regex(/^\+?[\d\s-]+$/, "Invalid phone number format"),
  vat: z.string().min(1, "Vat is required"),
});

export type SettingsFormData = z.infer<typeof settingsSchema>;
